export default {
  section: 'Subrecetas',
  dependencies: '¿Forzar borrado?',
  headers: {
    name: 'Nombre',
    production: 'Cantidad producida',
    cost: 'Costo',
    unitCost: 'Costo unitario',
    status: 'Estado',
    actions: 'Acciones'
  },
  labels: {
    uploadACsvFile: 'Por favor, selecciona un archivo CSV'
  },
  create: 'Crear una subreceta',
  edit: 'Editar una subreceta',
  duplicate: 'Dulpicar una subreceta',
  attach: 'Listar como producto',
  loading: 'Cargando subrecetas'
}
